if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.buttons = Array.from(this.querySelectorAll('button'));

        // Show only first tab’s products on page load
        if (this.buttons.length > 0) {
          this.buttons[0].classList.add('active');
          let firstHandle = this.buttons[0].dataset.collection;
          this.toggleCollection(firstHandle);
        }

        this.buttons.forEach((button) => {
          button.addEventListener('click', (event) => {
            let handle = button.dataset.collection;

            // remove active from all
            this.buttons.forEach(el => el.classList.remove('active'));
            button.classList.add('active');

            if (handle) {
              this.toggleCollection(handle);
            }

            event.preventDefault();
          });
        });
      }, 20);
    }

    toggleCollection(handle) {
      let grid = document.getElementById(this.target);

      // hide all
      grid.querySelectorAll('.columns').forEach(el => {
        el.style.display = 'none';
      });

      // show only selected
      grid.querySelectorAll(`[data-collection="${handle}"]`).forEach(el => {
        el.style.display = '';
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
